export default "__VITE_ASSET__b215948b__"